import LicenseTrialModel from '@shared/models/organizations/LicenseTrialModel';
import OrganizationMemberDetailsModel from '@shared/models/organizations/OrganizationMemberDetailsModel';
import { useEffect, useMemo, useState } from 'react';
import OrganizationContainer from './state/OrganizationContainer';

export function useCurrentTrial() {
    const organizationContainer = OrganizationContainer.useContainer();
    const [freeTrialOrg, setFreeTrialOrg] = useState<OrganizationMemberDetailsModel | null | undefined>(null);
    const [mostRecentTrial, setMostRecentTrial] = useState<LicenseTrialModel | null>(null);
    const canManageBilling = useMemo(() => {
        if (!freeTrialOrg) return false;
        return freeTrialOrg.isAdmin || freeTrialOrg.canManageBilling;
    }, [freeTrialOrg]);

    useEffect(() => {
        const isMemberPartOfOrganization = organizationContainer.membershipsRef.current?.length > 0;
        if (isMemberPartOfOrganization) {
            let mostRecentTrialOrg: OrganizationMemberDetailsModel | null = null;
            let mostRecentTrial: LicenseTrialModel | null = null;

            let found = false;
            for (const org of organizationContainer.membershipsRef.current) {
                if (found) break;
                if (!org.organization.hasLicense && org.organization.trials) {
                    const activeTrial = org.organization.trials.find(
                        (trial) => new Date(trial.expirationDate) > new Date()
                    );

                    if (activeTrial) {
                        mostRecentTrialOrg = org;
                        mostRecentTrial = activeTrial;
                    }

                    // if no active trial, set most recent trial
                    const recentTrial = org.organization.trials.reduce((latest, trial) => {
                        return new Date(trial.expirationDate) > new Date(latest.expirationDate) ? trial : latest;
                    }, org.organization.trials[0]);

                    if (
                        !mostRecentTrial ||
                        new Date(recentTrial.expirationDate) > new Date(mostRecentTrial.expirationDate)
                    ) {
                        mostRecentTrialOrg = org;
                        mostRecentTrial = recentTrial;
                    }

                    if (mostRecentTrial && mostRecentTrialOrg) {
                        found = true;
                        break;
                    }
                }
            }

            setFreeTrialOrg(mostRecentTrialOrg);
            setMostRecentTrial(mostRecentTrial);
        }
    }, [organizationContainer.memberships]);

    return { mostRecentTrial, freeTrialOrg, canManageBilling };
}
